import React from 'react';

import { HeightOutlined } from '@mui/icons-material';
import { ToggleButton } from '@mui/material';
import { BAR_HEIGHT_OPTIONS } from '@wp-block-builder/blocks/ProgressBar';

import { TooltipUnderline } from '@waypoint/react/atoms';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const ProgressBarSidebarForm = createBlockInputSection({
  title: 'Progress bar block',
  inputs: [
    {
      type: 'text',
      props: {
        label: 'Percentage value',
        name: 'percentageTemplate',
        autofocus: true,
        autohighlight: true,
        placeholder: '0',
        helperText: (
          <>
            Example:{' '}
            <TooltipUnderline title="Enter the variable name directly (without double curly braces).">
              <code>{'status.percentComplete'}</code>
            </TooltipUnderline>
            .
          </>
        ),
      },
    },
    {
      type: 'color',
      props: { label: 'Bar color', name: 'barColor' },
    },
    {
      type: 'color',
      props: { label: 'Track color', name: 'trackColor' },
    },
    {
      type: 'slider',
      props: {
        label: 'Height',
        name: 'barHeight',
        iconLabel: <HeightOutlined sx={{ color: 'text.secondary' }} />,
        units: 'px',
        step: 4,
        defaultValue: BAR_HEIGHT_OPTIONS.defaultValue,
        min: BAR_HEIGHT_OPTIONS.min,
        max: BAR_HEIGHT_OPTIONS.max,
      },
    },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Track shape',
        name: 'barShape',
        defaultValue: 'pill',
        children: [
          <ToggleButton key={1} value="rectangle">
            Rectangle
          </ToggleButton>,
          <ToggleButton key={2} value="rounded">
            Rounded
          </ToggleButton>,
          <ToggleButton key={3} value="pill">
            Pill
          </ToggleButton>,
        ],
      },
    },
    'backgroundColor',
    'padding',
    HideSectionInput,
  ],
});

export default ProgressBarSidebarForm;
